import fetchTrxCode from '@data/configuration/fetchTrxCode';
import { useQuery } from '@tanstack/react-query';

const getTrxCode = () => {
    return useQuery({
        queryKey: ['trx-code'],
        queryFn: fetchTrxCode,
        staleTime: Infinity,
    });
};

export default getTrxCode;
